import React, { useContext, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Header from './Header'
import Menu from './Menu'
import { Outlet, useNavigate } from 'react-router-dom'
import { notificacao } from '../components/api'
import { GlobalContext } from '../App'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 2),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
}))

const Interface = () => {
  const { dispatch, verificaLogin } = useContext(GlobalContext)

  const navigate = useNavigate()

  const buscaNotificacoes = async () => {
    const { lista } = await notificacao()
    dispatch({ field: 'notificacoes', value: lista })
  }

  useEffect(() => {
    verificaLogin(null, navigate, window.location)
    const localAtendimento = localStorage.getItem('selectedLocalAtendimento')

    if (localAtendimento) {
      dispatch({
        type: 'setLocalAtendimento',
        value: JSON.parse(localAtendimento),
      })
    }
    buscaNotificacoes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Header />
      <Menu />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Outlet />
      </main>
    </div>
  )
}

export default Interface
